type Listener = (isOpen: boolean) => void;
let openCount = 0;
const listeners = new Set<Listener>();

function notify() {
  const isOpen = openCount > 0;
  listeners.forEach(l => l(isOpen));
}

export function notifyModalOpen() {
  openCount++;
  notify();
}

export function notifyModalClose() {
  openCount = Math.max(0, openCount - 1);
  notify();
}

export function subscribeToModalState(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
